import { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { chartPercent, percentParts } from '../../utils/utils'

const StyledDiv = styled.div`
  position: relative;
  height: ${p => (p.height ? `${p.height}px` : null)};
  width: ${p => (p.width ? `${p.width}px` : null)};
  padding: ${p => (p.padding ? `${p.padding}px` : null)};
`
const Track = styled.circle`
  fill: ${p => p.theme.lightestGray};
`
const Arc = styled.path`
  fill: ${p => p.theme.primaryColor};
`
const Text = styled.text`
  font-size: 20px;
  vertical-align: middle;
  line-height: 1;
  text-anchor: middle;
  text-align: center;
  cursor: default;
  user-select: none;
  font-weight: ${p => p.labelWeight};
  fill: ${p => p.labelColor || (p.isOld ? p.theme.darkestGray : p.theme.primaryColor)};
`
const PercentSign = styled.tspan`
  font-size: 20px;
  line-height: 1;
  text-anchor: middle;
  text-align: center;
  cursor: default;
  fill: ${p => p.labelColor || (p.isOld ? p.theme.lightestGray : p.theme.primaryColor)};
  user-select: none;
`

class DoughnutChart extends Component {
  render() {
    const {
      percent = 0,
      isOld = true,
      height = 100,
      className,
      labelColor,
      labelWeight = 400,
    } = this.props
    const centerWidth = height / 2
    const centerHeight = height / 2
    const radius = height / 2

    const arcPercent = chartPercent(percent)
    const { prefix, value: labelValue } = percentParts(percent)

    const trigPercent = (arcPercent / 100) * 2 * Math.PI
    const xPos = centerWidth + Math.cos(trigPercent - Math.PI / 2) * radius
    const yPos = centerHeight + Math.sin(trigPercent - Math.PI / 2) * radius

    return (
      <StyledDiv width={height} height={height} padding={2} className={className}>
        <svg width='100%' height='100%' viewBox={`0 0 ${height} ${height}`}>
          {arcPercent < 100 ? (
            <>
              <Track cx={centerWidth} cy={centerHeight} r={radius} />
              <Arc
                d={`M ${centerWidth} 0 A ${radius} ${radius} 0 ${
                  arcPercent > 50 ? 1 : 0
                } 1 ${xPos} ${yPos} L ${centerWidth} ${centerHeight}`}
              />
            </>
          ) : (
            <Arc as='circle' cx={centerWidth} cy={centerHeight} r={radius} />
          )}

          <circle cx={centerWidth} cy={centerHeight} r={radius / 1.75} fill='#FFFFFF' />
          <Text
            x={centerWidth}
            y={centerHeight}
            dy='0.35em'
            isOld={isOld}
            labelColor={labelColor}
            labelWeight={labelWeight}>
            {`${prefix}${labelValue}`}
            <PercentSign isOld={isOld} labelColor={labelColor}>
              %
            </PercentSign>
          </Text>
        </svg>
      </StyledDiv>
    )
  }
}

DoughnutChart.propTypes = {
  /** Percentage from 0–100. Labels round; arcs preserve the value with a 1% minimum. */
  percent: PropTypes.number,
  /** Uses current-value colors when true and planned-value colors when false. */
  isOld: PropTypes.bool,
  labelColor: PropTypes.string,
  labelWeight: PropTypes.number,
  /** Controls both dimensions of the square chart, in pixels. */
  height: PropTypes.number,
  className: PropTypes.string,
}

export default DoughnutChart
